import gql from 'graphql-tag';
import FieldsBuilding from "graphql/fields/FieldsBuilding";

export default gql(`
	query buildings {
		buildings {
			${FieldsBuilding}
		}
	}
`);

